import { render, staticRenderFns } from "./temuManifestDetail.vue?vue&type=template&id=8d2d279a&scoped=true"
import script from "./temuManifestDetail.vue?vue&type=script&lang=js"
export * from "./temuManifestDetail.vue?vue&type=script&lang=js"
import style0 from "./temuManifestDetail.vue?vue&type=style&index=0&id=8d2d279a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d2d279a",
  null
  
)

export default component.exports